export const professionScopes = [
    {id: 0, label: "ds_p_0"},
    {id: 1, label: "ds_p_1"},
    {id: 2, label: "ds_p_2"},
    {id: 3, label: "ds_p_3"},
    {id: 4, label: "ds_p_4"},
    {id: 5, label: "ds_p_5"},
    {id: 6, label: "ds_p_6"},
    {id: 7, label: "ds_p_7"},
    {id: 8, label: "ds_p_8"},
    {id: 9, label: "ds_p_9"},
    {id: 10, label: "ds_p_10"},
    {id: 11, label: "ds_p_11"},
    {id: 12, label: "ds_p_12"},
    {id: 13, label: "ds_p_13"},
    {id: 14, label: "ds_p_14"},
    {id: 15, label: "ds_p_15"},
    {id: 16, label: "ds_p_16"},
    {id: 17, label: "ds_p_17"},
    {id: 18, label: "ds_p_18"},
    {id: 19, label: "ds_p_19"},
    {id: 20, label: "ds_p_20"},
    {id: 21, label: "ds_p_21"},
    {id: 22, label: "ds_p_22"},
    {id: 23, label: "ds_p_23"},
    {id: 24, label: "ds_p_24"},
    {id: 25, label: "ds_p_25"},
    {id: 26, label: "ds_p_26"},
    {id: 27, label: "ds_p_27"},
    {id: 28, label: "ds_p_28"},
    {id: 29, label: "ds_p_29"},
    {id: 30, label: "ds_p_30"},
    {id: 31, label: "ds_p_31"},
    {id: 32, label: "ds_p_32"},
    {id: 33, label: "ds_p_33"},
    {id: 34, label: "ds_p_34"}
];
